import { Component, EventEmitter, Input, OnInit, Output ,OnDestroy} from "@angular/core";
import { BaseComponent } from "../../shared/base/base-component";
import { AlertService } from "../../alert-panel/alert.service";
import { LoggingPanelModel } from "../../_models/common/LoggingPanelModel";
import { LogObjectActionTemplateEnum } from "../../_models";
import { LoggingPanelService } from "../../_services/logging-panel/logging-panel.service";
import { ClaimsService } from "../../_services/common/claims.service";
import { Claims } from "../../_models/common/claims";
import { TranslateService } from "@ngx-translate/core";
import { StateService } from "../../_services";
import { TaxRateService } from "../../_services/tax-rate/tax-rate.service";
import { TaxSetupRequest, TaxSetupRequestInfo } from "../../_models/tax-rate/tax-setup-request";
import { ToastrService } from "ngx-toastr";
import { InformationAlertPanelModel } from "../../_models/common/informationAlertPanelModel";
import { HowDoIVideoLinks }  from "src/app/common/commonvariables";
import { Subscription } from "rxjs";
import { AlertPanelModel } from "src/app/_models/common/alertPanelModel";
import { TourService } from '../../_tour/tour.service';
import { ActivatedRoute, Router } from "@angular/router";
@Component({
    selector: 'app-tax-setup-step1',
    templateUrl: './tax-setup-step1.component.html',
    standalone: false
})

export class TaxSetupStep1Component extends BaseComponent implements OnInit ,OnDestroy{
  @Input() fmSpecialObject: any;
    @Input() panelHeader: string;
    @Output() closePanelEvent = new EventEmitter<boolean>();
    hasFormChanges:boolean;
    claims: Claims;
    IsINRCurrency: boolean;
    taxNamePlaceHolder: string;
    RateCode: string;
    param: string;
    setVAT:boolean;
    setGST:boolean;
    statesList: any[];
    StateIdSelected: number;
    StateNameSelected: string;
    taxSetupRequest: TaxSetupRequest;
    taxSetupRequestInfo: TaxSetupRequestInfo;
    IsSingleRate:boolean;
    TaxSetupId: number = 0;
    CanChangeTaxType: boolean;
    IsChangeInTaxType: boolean;
    taxChangeAlertPanelModel = new AlertPanelModel(
      false,
      "",
      [""],
      "",
      "",
      true,
      this.translate.instant("close")
    );
    videoLink = HowDoIVideoLinks.TaxSetupStep2;
    showTaxChangeAlert: boolean;
    alertSubscription: Subscription;
    isStateNotSelected: boolean = false;
    constructor(
        private alertService : AlertService,
        private loggingPanelService: LoggingPanelService,
        private claimsService: ClaimsService,
        private translate: TranslateService,
        private stateService: StateService,
        private taxRateService: TaxRateService,
        private toastr: ToastrService,
        private tourService: TourService,
        private route: ActivatedRoute,
    ){
     super();
     this.claimsService.currentClaims.subscribe((claims) => {
        this.claims = claims;
        this.IsINRCurrency =
          this.claims.CurrentOrganisationCurrency.includes("INR");
      });
      this.alertSubscription = this.alertService
      .getUserActionEvent()
      .subscribe((action) => {
        if (action) {
          this.hasFormChanges = false;
          this.closePanelEvent.emit(true);
        }
      });
    }

    ngOnInit(): void {
        this.showTaxChangeAlert=false;
        this.hasFormChanges=false; 
        this.RateCode = '';
        this.TaxSetupId=0;
        this.setVAT = false;
        this.setGST = false;
        this.IsSingleRate = true;
        this.taxNamePlaceHolder = this.translate.instant("tax_name_placeholder");
        this.BindTaxSetup();
        this.checkForExpenseCount();
        this.fnStartTour();
    }

    fnBacktoWizard()
    {
        if (this.canDeactivate()) {
          if(this.fmSpecialObject) {
            this.closePanelEvent.emit(this.fmSpecialObject); 
          }
          else
          {
            this.closePanelEvent.emit(true); 
          }
                
        }
        else {
            this.alertService.onFormClosed();
        }     
    }

    canDeactivate(): boolean {
        return !this.hasFormChanges;
    }

    
    ngOnDestroy() {
      this.tourService.destroyParallelPopups();
    }


    fnShowConfigureshowLoggingAlertPanel() {
        const model = new LoggingPanelModel(
          this.claims.OrgId.toString(),
          LogObjectActionTemplateEnum.SetupvatsRate.toString(),
          "0"
        );
        this.loggingPanelService.onShowLogPanel(model);
    }

    onTaxNameChange() {
      this.hasFormChanges = true;
    }

    stateChanged(events: any) {
      this.SetSelectedStateValue(true);
    }
    
    SetSelectedStateValue(IsFormChanged:boolean) {
      if (this.statesList != null && this.statesList.length > 0 && this.StateIdSelected && this.StateIdSelected > 0)
        this.StateNameSelected = this.statesList.filter(
          (id) => id.stateId == this.StateIdSelected
        )[0].stateName;
      this.hasFormChanges = IsFormChanged;
      this.isStateNotSelected = false;
    }

    fnSetVATtype(fxRateRule:number,IsChanged:boolean)
    {
      if(this.fmSpecialObject) {
          this.hasFormChanges=true;
        }
        else
        {
          this.hasFormChanges=IsChanged;   
        }
      this.setVAT=false;
      this.setGST=false;
      if(this.CanChangeTaxType && IsChanged)
      {
        this.showTaxChangeAlert=true;
        this.fnShowChangeTaxAlertPanel();            
      }
      else
      {
        switch(fxRateRule)
        {
            case 1: this.setVAT = true;
                    this.IsSingleRate=true;
                    this.RateCode = this.TaxSetupId == 0 ? this.translate.instant('tax_vat') : this.RateCode;
                        break;
            case 2: this.setGST = true;
                    this.IsSingleRate=false;
                    this.RateCode = this.TaxSetupId == 0 ? this.translate.instant('tax_gst') : this.RateCode;
                    this.BindStates(IsChanged);
                        break;  
        }    
      }
          
    }

    BindStates(IsChanged : boolean) {
      this.stateService
        .getExpenseState()
        .pipe()
        .subscribe((data) => {
          this.statesList = data;
          this.SetSelectedStateValue(IsChanged);
        });
    }

    BindTaxSetup() {
      var request = new TaxSetupRequest();
      request.requestId = "1";
      request.webApiName = "getTaxRateMasterByOrg";
      request.webApiVersion = 1;
      request.requestInfo = new TaxSetupRequestInfo();
      request.requestInfo.organisationId = this.claims.OrgId;
  
      this.taxRateService
        .getTaxSetuByOrg(request, "")
        .pipe()
        .subscribe((data) => {
          if (data.statusCode == 0) {
            this.taxSetupRequestInfo = data.responseInfo;
            if (this.taxSetupRequestInfo) {
              this.IsSingleRate = this.taxSetupRequestInfo.isSingleTaxRate;
              this.TaxSetupId = this.taxSetupRequestInfo.taxSetupId;              
              this.RateCode = this.taxSetupRequestInfo.rateCode;
              this.TaxSetupId = this.taxSetupRequestInfo.taxSetupId;
              this.StateIdSelected = this.taxSetupRequestInfo.stateId;            
            }
            this.fnSetTaxTypeSelection(this.IsSingleRate);
            
          }
        });
    }

    fnSetTaxTypeSelection(IsSingleRate: boolean)
    {
      let isInitialSetup = this.taxSetupRequestInfo == null || this.taxSetupRequestInfo == undefined;
      if(IsSingleRate)
        this.fnSetVATtype(1,isInitialSetup);
      else
        this.fnSetVATtype(2,false);      
    }

    checkForExpenseCount() {
      var request = <any>{};
      request.WebApiName = "OrgExpenseCategory";
      request.RequestId = "1";
      request.WebApiVersion = 1;
      request.RequestInfo = this.claims.OrgId;
  
      this.taxRateService.checkExpenseCount(request).subscribe((data) => {
        this.CanChangeTaxType =
          data.responseInfo.totalExpense > 0 && this.TaxSetupId > 0;        
      });
    }

    Save() {
      
      if (this.RateCode == undefined || this.RateCode.trim() == "") {
        return;
      }
  
      if (this.IsSingleRate === false &&
        this.IsINRCurrency &&
        (this.StateIdSelected === 0 || this.StateIdSelected === undefined)         
      ) {
        this.isStateNotSelected = true;
        return;
      }
  
      this.taxSetupRequest = new TaxSetupRequest();
      this.taxSetupRequest.requestId = "1";
      this.taxSetupRequest.webApiName = "SaveTaxSetup";
      this.taxSetupRequest.webApiVersion = 1;
      this.taxSetupRequest.requestInfo = new TaxSetupRequestInfo();
      this.taxSetupRequest.requestInfo.taxSetupId = this.TaxSetupId;
      this.taxSetupRequest.requestInfo.rateCode = this.RateCode;
      this.taxSetupRequest.requestInfo.organisationId = this.claims.OrgId;
      this.taxSetupRequest.requestInfo.isSingleTaxRate = this.setVAT ? true : false;
      this.taxSetupRequest.requestInfo.isTaxRateOn = true;
      this.taxSetupRequest.requestInfo.stateId = this.StateIdSelected;
      this.taxSetupRequest.requestInfo.createdBy = this.claims.UserId;
      this.taxSetupRequest.requestInfo.updatedBy = this.claims.UserId;
      this.taxSetupRequest.requestInfo.createdOn = null;
      this.taxSetupRequest.requestInfo.updatedOn = null;
      this.taxSetupRequest.requestInfo.wizardStep = 2;

      this.taxRateService
        .saveTaxSetup(this.taxSetupRequest, "")
        .pipe()
        .subscribe((data) => {
          if (data.statusCode == 0) {
            this.TaxSetupId = data.responseInfo.taxSetupId;              
            this.RateCode = data.responseInfo.rateCode;             
            this.toastr.success(this.translate.instant("success"));
            this.hasFormChanges = false;
            if(this.fmSpecialObject)
            {
              this.fmSpecialObject.nextPanel = true;
            }
          }
        });
    }

    fnShowChangeTaxAlertPanel()
    {
      this.taxChangeAlertPanelModel = new AlertPanelModel(
        true,
        this.translate.instant("info"),
        [this.translate.instant("tax_rate_setup_delete_msg")],
        this.translate.instant("label_cancel"),
        '',
        true,
        ''
      );
    }

    fnCloseTaxChangeAlertPanel(events)
    {
      this.showTaxChangeAlert=false;
      this.taxChangeAlertPanelModel = new AlertPanelModel(
        false,
        "",
        [""],
        "",
        "",
        true,
        this.translate.instant("close")
      );
      this.fnSetTaxTypeSelection(this.IsSingleRate);
    }

  fnStartTour(){
    const showTour = Boolean(this.route.snapshot.queryParams?.showTour);
    if (!showTour) return;
    this.tourService.showParallelFromRegistry('setup-tax-name-method-panel-tour');
  }
}